import { type FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useBlocNext } from "@blac/react";
import LeapChatCubit, { formatConversationDate } from "./LeapChatCubit";
import {
  ArchiveList,
  ArchiveHeader,
  ArchiveItem,
  LeapChatContentPositioner,
  LeapChatViewport
} from "./leapChat.styles";

const ArchiveView: FC = () => {
  const [{ conversations }, cubit] = useBlocNext(LeapChatCubit);
  const navigate = useNavigate();

  useEffect(() => {
    cubit.clearActiveConversation();
    void cubit.listConversations();
  }, [cubit]);

  return (
    <LeapChatContentPositioner>
      <LeapChatViewport>
        <ArchiveList>
          <ArchiveHeader>Your conversations</ArchiveHeader>
          {conversations.map((conv) => (
            <ArchiveItem
              key={conv.id}
              onClick={() => navigate(`/app/chat/conversation/${conv.id}`)}
            >
              <span className="archive-item-title">
                {conv.title || "Untitled conversation"}
              </span>
              <span className="archive-item-date">
                {formatConversationDate(conv.createdAt)}
              </span>
              {conv.summary && (
                <span className="archive-item-summary">{conv.summary}</span>
              )}
            </ArchiveItem>
          ))}
        </ArchiveList>
      </LeapChatViewport>
    </LeapChatContentPositioner>
  );
};

export default ArchiveView;
